import { render, staticRenderFns } from "./ListType.vue?vue&type=template&id=6c6fc70d&scoped=true&"
import script from "./ListType.vue?vue&type=script&lang=js&"
export * from "./ListType.vue?vue&type=script&lang=js&"
import style0 from "./ListType.vue?vue&type=style&index=0&id=6c6fc70d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6fc70d",
  null
  
)

export default component.exports